export const ORG = "Spire Inclusion";

export const LOGO = "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/ugu0k2bc_IMG-20260626-WA0021.png";

export const CONTACT = {
  phone: "07890 052408",
  email: "spireinclusion@gmail.com",
  address: "96 St Michael's Rd, Salisbury, SP2 9LE",
  hours: "Monday to Friday, 10:00am – 3:30pm",
  safeguarding: "0300 456 0111",
  safeguardingHours: "Monday to Thursday, 8.30am – 5pm (Friday until 4pm)",
  safeguardingOOH: "Emergency Duty Service: 0300 456 0100",
};

export const SOCIALS = [
  { name: "Facebook", href: "https://www.facebook.com/spireinclusion" },
  { name: "Instagram", href: "https://www.instagram.com/spire_inclusion?igsh=ZXFpZXl2Z21jNnB3" },
  { name: "TikTok", href: "https://www.tiktok.com/@spire.inclusion?_r=1&_t=ZN-97Zbrpi6AnW" },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "What We Do", to: "/what-we-do" },
  { label: "A Typical Week", to: "/a-typical-week" },
  { label: "How We Support People", to: "/how-we-support-people" },
  { label: "Families & Carers", to: "/families-and-carers" },
  { label: "Gallery", to: "/gallery" },
  { label: "Safeguarding", to: "/safeguarding-and-complaints" },
  { label: "News", to: "/news" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export const FOOTER_LINKS = [
  { label: "Easy Read", to: "/easy-read" },
  { label: "Accessibility Statement", to: "/accessibility-statement" },
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Cookie Policy", to: "/cookie-policy" },
  { label: "Safeguarding & Complaints", to: "/safeguarding-and-complaints" },
];

export const LIFE_SKILLS_PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/kq5fn77i_IMG-20260619-WA0004.jpg",
    alt: "A support worker helping someone we support measure baking ingredients during a cooking session.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/u44hwfev_IMG-20260626-WA0004.jpg",
    alt: "A group of people we support and a support worker enjoying a meal out together at a restaurant.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/eag9kq0v_IMG-20260612-WA0026.jpg",
    alt: "Someone we support proudly presenting a homemade pizza they prepared in a cooking session.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/p23d6o5d_IMG-20260626-WA0016.jpg",
    alt: "Someone we support carefully mixing cake batter in a bowl during a baking session.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/8zjnqp9i_IMG-20260604-WA0026.jpg",
    alt: "Someone we support spooning flapjack mixture into a baking tin during a cooking session.",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/ef9981fc-a13a-4964-8208-3688ddaf2af7/images/e16e9903ce5217d6c319df40a9189d0243d48f6d913895244e5ba6df6bbaffb9.png",
    alt: "Three people we support enjoying a meal out together at a pub, practising ordering and eating in the community.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/pxcpp1g3_IMG-20260623-WA0043.jpg",
    alt: "Someone we support proudly showing the chocolate tray bake they made during a cooking session.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/miokh40o_IMG-20260522-WA0044.jpg",
    alt: "A group from Spire Inclusion enjoying a meal out together at a Harvester restaurant.",
  },
];

export const MOSAIC = [
  { src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/hjrnzf5p_IMG-20260619-WA0003.jpg", alt: "A group from Spire Inclusion enjoying a trip to the cinema together." },
  { src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/m43l3sbf_IMG-20260520-WA0028.jpg", alt: "Three people we support smiling and making peace signs on a day out." },
  { src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/kq5fn77i_IMG-20260619-WA0004.jpg", alt: "A support worker helping someone we support with a cooking session." },
  { src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/gyxnf2xn_IMG-20260515-WA0049.jpg", alt: "Someone we support playing a lively ball game on an outdoor court." },
  { src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/i22nwezu_IMG-20260522-WA0021.jpg", alt: "People we support watching the penguins at a wildlife park." },
  { src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/uecqaya5_20260623_135433.jpg", alt: "Someone we support shaping clay in a craft session." },
  { src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/hz4qbkr1_IMG-20260611-WA0003.jpg", alt: "Two people we support enjoying an interactive sensory light floor game." },
  { src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/l61b2nnr_IMG-20260520-WA0069.jpg", alt: "Someone we support posing with a hippo sculpture at a wildlife park." },
];

export const ACTIVITY_PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/gyxnf2xn_IMG-20260515-WA0049.jpg",
    alt: "Someone we support playing a lively ball game on an outdoor sports court.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/rlk7h8jj_IMG-20260508-WA0002.jpg",
    alt: "A young man we support giving a thumbs up during a hockey session on an astroturf pitch.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/uecqaya5_20260623_135433.jpg",
    alt: "Someone we support concentrating while shaping clay with a rolling pin in a craft session.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/lcpxqyy4_IMG-20260526-WA0011.jpg",
    alt: "A young man we support smiling during a fun summer water fight outdoors.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/ppl1l29g_IMG-20260611-WA0026.jpg",
    alt: "People we support taking part in an energetic dance and performance class with an instructor.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/4ss3djui_IMG-20260610-WA0013.jpg",
    alt: "Someone we support swimming confidently in an indoor pool wearing goggles.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/uypf26t3_IMG-20260626-WA0005.jpg",
    alt: "Someone we support batting during a game of cricket on a sunny field.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/sl2etgr1_IMG-20260619-WA0017.jpg",
    alt: "Someone we support playing badminton with a racquet and shuttlecock on a grassy field.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/hz4qbkr1_IMG-20260611-WA0003.jpg",
    alt: "Two people we support enjoying an interactive sensory light floor game and sharing a high five.",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/ef9981fc-a13a-4964-8208-3688ddaf2af7/images/9c76991d2651be95c619e9793bb62d9c3924b92c8cd1c9438fbdcb48b0010e36.png",
    alt: "Someone we support enjoying an energetic hula hoop workout on an outdoor sports court.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/6krab0od_IMG-20260521-WA0006.jpg",
    alt: "Someone we support and a support worker enjoying a game of football together on an outdoor court.",
  },
];

export const TRIPS = [
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/l976xqmr_20260623_110155.jpg",
    alt: "People we support enjoying a sunny day out together.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/m43l3sbf_IMG-20260520-WA0028.jpg",
    alt: "A happy group from Spire Inclusion smiling on a day out.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/uusj9jra_IMG-20260520-WA0046.jpg",
    alt: "People we support having fun on a day trip.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/k1bvj38r_IMG-20260626-WA0020.jpg",
    alt: "A joyful moment from one of our days out.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/zy1dy1rd_IMG-20260520-WA0038.jpg",
    alt: "Someone we support relaxing outdoors on a day out.",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/ef9981fc-a13a-4964-8208-3688ddaf2af7/images/ccf3326f18a3c1f0a86d8fa86154186773ce10f0732542d7cf04e2a96d6fb556.png",
    alt: "Someone we support travelling confidently by bus, smartly dressed.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/hjrnzf5p_IMG-20260619-WA0003.jpg",
    alt: "A group from Spire Inclusion enjoying a trip to the cinema together.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/l61b2nnr_IMG-20260520-WA0069.jpg",
    alt: "Someone we support having fun posing with a hippo sculpture at a wildlife park.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/i22nwezu_IMG-20260522-WA0021.jpg",
    alt: "People we support watching the penguins at a wildlife park.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/dxha0u8a_IMG-20260626-WA0015.jpg",
    alt: "Two people we support sharing a laugh in historic cathedral cloisters.",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/ef9981fc-a13a-4964-8208-3688ddaf2af7/images/3698947964e510dc5846369e41e5cd090974f1ebf3b9acb87646b042e3b87dc6.png",
    alt: "Someone we support enjoying a relaxed drink and a bite to eat at the community breakfast club.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/v0nq4r7d_IMG-20260626-WA0018.jpg",
    alt: "A group from Spire Inclusion enjoying a sociable meal out together at a local pub.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/ogroi0z4_IMG-20260626-WA0012.jpg",
    alt: "Someone we support enjoying a packed lunch on a bench during a day out in the park.",
  },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/8777809/pexels-photo-8777809.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cooking: "https://images.unsplash.com/photo-1683624328172-88fb24625ec1?auto=format&fit=crop&w=940&q=70",
  group: "https://images.pexels.com/photos/8777800/pexels-photo-8777800.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  friends: "https://images.pexels.com/photos/6767012/pexels-photo-6767012.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
